'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Abstracted fetch API call for retrieving JSON data. Defaults to GET.
 * @example await fetchJson<MyInterface>({ url: 'https://mywebsite.com/api/stuff' })
 * @param options FetchJsonOptions<Body>
 * @returns Promise<T>
 */ const fetchJson = async (options)=>{
    const { bearerToken , body , contentType ='application/json' , credentials , error , fields , headers , include , method ='GET' , params , queuePriorityHigh =true , returnFetchError =false , signal , url  } = options;
    let fetchBody = null;
    if (body) {
        fetchBody = contentType === 'application/json' ? JSON.stringify({
            ...body,
            ...queuePriorityHigh && {
                queue_priority: 'high'
            }
        }) : body;
    }
    const requestUrl = new URL(url, window.location.origin);
    if (!body && queuePriorityHigh) {
        requestUrl.searchParams.append('queue_priority', 'high');
    }
    if (fields) {
        requestUrl.searchParams.append('fields', Array.isArray(fields) ? fields.join(',') : fields);
    }
    if (include) {
        requestUrl.searchParams.append('include', Array.isArray(include) ? include.join(',') : include);
    }
    if (params) {
        for (const key of Object.keys(params)){
            if (params[key] !== undefined && params[key] !== null) {
                requestUrl.searchParams.append(key, params[key].toString());
            }
        }
    }
    try {
        const response = await fetch(requestUrl.toString(), {
            body: fetchBody,
            credentials,
            headers: {
                ...bearerToken && {
                    Authorization: `Bearer ${bearerToken}`
                },
                ...method !== 'GET' && {
                    'Content-Type': contentType
                },
                ...headers
            },
            method,
            signal
        });
        // this needs to be before response.ok, because you can't do response.json() after response.ok
        // (json will be undefined when doing "const json = await response.json()", not sure why)
        const json = response.status === 204 ? {} : await response.json();
        if (response.ok || response.status >= 200 && response.status < 300) {
            return await Promise.resolve(json);
        } else if (response.status === 422 || response.status === 409) {
            // eslint-disable-next-line unicorn/no-useless-promise-resolve-reject
            return Promise.reject(json);
        } else {
            if (returnFetchError) {
                const fetchError = {
                    error: new Error(error || json?.errors?.[0]?.detail || ''),
                    errors: Array.isArray(json?.errors) ? json.errors : [],
                    method,
                    response
                };
                // eslint-disable-next-line unicorn/no-useless-promise-resolve-reject
                return Promise.reject(fetchError);
            } else {
                throw new Error(error || '');
            }
        }
    } catch (serverError) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const err = serverError;
        if (returnFetchError) {
            const fetchError = {
                error: new Error(error || err?.message || err?.errors?.[0]?.detail || ''),
                errors: Array.isArray(err?.errors) ? err.errors : [],
                method
            };
            // eslint-disable-next-line unicorn/no-useless-promise-resolve-reject
            return Promise.reject(fetchError);
        } else {
            // eslint-disable-next-line unicorn/no-useless-promise-resolve-reject
            return Promise.reject(new Error(error || err?.message || err?.errors?.[0]?.detail || err?.errors || ''));
        }
    }
};

exports.fetchJson = fetchJson;
//# sourceMappingURL=fetch.js.map
